export default "__VITE_ASSET__B70ZsuH2__"